// code source from stackoverflow

import camelCase from "lodash/camelCase";

const requireModule = require.context(".", false, /\.js$/); //extract js files inside modules folder
const modules = {};

requireModule.keys().forEach(fileName => {
  if (fileName === "./index.js") return; //reject the index.js file

  const moduleName = camelCase(fileName.replace(/(\.\/|\.js)/g, "")); //

  const moduleDefinition = requireModule(fileName)

  modules[moduleName] = {
    ...moduleDefinition,
    namespaced: true
  };
});

console.log(modules)

export default modules



// WEBPACK FOOTER //
// ./src/store/modules/index.js